import { render, staticRenderFns } from "./drawrule.vue?vue&type=template&id=2d09b8b9&scoped=true&"
import script from "./drawrule.vue?vue&type=script&lang=js&"
export * from "./drawrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d09b8b9",
  null
  
)

export default component.exports